import http from '@root/utils/axios/admin';

let state = {
    GroupCardRechargesAssignList: [],
    GroupCardRechargeAssign: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGroupCardRechargesAssignList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/group-recharge-card-ready-assign', { params: filter }).then((response) => {
                commit('setGroupCardRechargesAssign', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGroupCardRechargeAssign({ commit }, data) {
        return http.post('/api/group-recharge-card-ready-assign', data);
    },

    fetchGroupCardRechargeAssign({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/group-recharge-cards/' + id).then((response) => {
                commit('setGroupCardRechargeAssign', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    addToReadyToAssign({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-card-ready-assign', data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },
    confirmAssign({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-card-assign', data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeAssignError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGroupCardRechargeAssign({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-cards/' + data.id, data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGroupCardRechargesAssign(state, data) {
        state.GroupCardRechargesAssignList = data;
    },
    setGroupCardRechargeAssign(state, data) {
        state.GroupCardRechargeAssign.data = data;
    },
    setGroupCardRechargeAssignError(state, error) {

        state.GroupCardRechargeAssign.error = error.errors;
    },
    cleanCardRechargeAssignError(state, error) {
        state.GroupCardRechargeAssign.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}